import { Component, ChangeDetectionStrategy, Output, EventEmitter, HostListener, ChangeDetectorRef, ViewRef } from '@angular/core';
import { Column } from '../../models/column';
import { HelperService } from '../../Services/Helper.Service';

@Component({
  selector: 'mdg-columns',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div *ngIf="showColumns" class='mdg-filter-container'>
  <div class="mdg-filter-popup-container">
    <div class='row'>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <div class='row'>
          <div class="col-md-6 col-sm-6 col-xs-12 col-lg-6">
            <h3>Fields</h3>
          </div>
        </div>
        <hr class="buffer-5-0">
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 content">
        <div class='border-top-ddd border-left-ddd border-right-ddd'>
          <div class="padding-5 bg-f7f7f7">List of Columns
            <div class="pull-right right-buffer-10">
              <i class='fa cursor-pointer' (click)='checkSelection()' [class.fa-check-square-o]='selectAll' [class.padding-right-2]='!selectAll'
                [class.fa-square-o]='!selectAll'></i>
            </div>
          </div>
        </div>
        <div class="mdg-filter-stack-container overflow-y border-ddd">
          <div class="border-bottom-ddd padding-5 mdg-filter-cell" *ngFor="let col of columns" [class.text-bold]='col.checked' [title]="col.displayName">
            <div>
              <i class='fa fa-reorder cursor-move font-10'></i>
            </div>
            <div>{{ col.displayName }}</div>
            <div>
              <i class='fa cursor-pointer' (click)='addColumn(col)' [class.fa-check-square-o]='col.checked' [class.fa-square-o]='!col.checked'></i>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <hr class="buffer-5-0">
        <div class='row'>
          <div class="col-xs-12 text-lg-right text-md-right text-sm-right">
            <button class='btn btn-sm btn-primary right-buffer-10' (click)='applyColumns()'>Apply</button>
            <button class='btn btn-sm btn-default' (click)='showColumns = false'>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`
})
export class MDGColumnsComponent {
  columns: Column[] = [];
  @Output() updateColumns: EventEmitter<Column[]> = new EventEmitter<Column[]>();
  showColumns: boolean = false;
  selectAll: boolean = false;

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.showColumns) {
      this.showColumns = false;
    }
  }

  constructor(private cdRef: ChangeDetectorRef, private helper: HelperService) { }

  ShowColumns(cols: Column[]) {
    this.columns = this.helper.copyArray(cols);
    this.checkAllSelected();
    this.showColumns = true;
    this.detectChanges();
  }

  checkSelection() {
    this.selectAll = !this.selectAll;
    this.columns.forEach(col => {
      col.checked = this.selectAll;
    });
  }

  checkAllSelected() {
    this.selectAll = this.columns.filter(f => f.checked).length === this.columns.length;
  }

  addColumn(col: any) {
    col.checked = !col.checked;
    this.checkAllSelected();
  }

  applyColumns() {
    this.updateColumns.emit(this.columns.filter(f => f.checked === true));
    this.showColumns = false;
  }

  getDisplayDate(input: string) {
    return (new Date(input)).toLocaleDateString();
  }

  detectChanges() {
    setTimeout(() => {
      if (
        this.cdRef !== null &&
        this.cdRef !== undefined &&
        !(this.cdRef as ViewRef).destroyed
      ) {
        this.cdRef.detectChanges();
      }
    }, 250);
  }

}
